module.exports = __webpack_public_path__ + "static/sport/bgi-m.9616a68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/bgi-m.png
// module id = NTUS
// module chunks = 0